export default __webpack_public_path__ + "static/media/fr.2c0a89ad.svg";